import { defineMessages } from 'react-intl';

import { baseCardsSchema } from '../Cards/schema';

const messages = defineMessages({
  listingPersons: {
    id: 'Listing persons',
    defaultMessage: 'Listing persons',
  },
  personsPerRow: {
    id: 'Persons per row',
    defaultMessage: 'Persons per row',
  },
  threePerRow: { id: 'Three per row', defaultMessage: 'Three per row' },
  onePerRow: { id: 'One per row', defaultMessage: 'One per row' },
  twoPerRow: { id: 'Two per row', defaultMessage: 'Two per row' },
  fourPerRow: { id: 'Four per row', defaultMessage: 'Four per row' },
  fivePerRow: { id: 'Five per row', defaultMessage: 'Five per row' },
  showPersonsDescriptions: {
    id: 'Show persons descriptions',
    defaultMessage: 'Show persons descriptions',
  },
  showPersons: {
    id: 'Show persons',
    defaultMessage: 'Show persons',
  },
  personCardLayout: {
    id: 'Person card layout',
    defaultMessage: 'Person card layout',
  },
  showPersonsAllLinks: {
    id: 'Show all agenda/curriculum links',
    defaultMessage: 'Show all links (agenda history & curriculum)',
  },
  showPersonsSubstitute: {
    id: 'Show substitutes',
    defaultMessage: 'Show substitutes',
  },
  horizontal: { id: 'Horizontal', defaultMessage: 'Horizontal' },
  vertical: { id: 'Vertical', defaultMessage: 'Vertical' },
  summaryCard: { id: 'Summary Card', defaultMessage: 'Summary Card' },
  fieldsetDefault: { id: 'Default', defaultMessage: 'Default' },
  fieldsetPersons: { id: 'Persons', defaultMessage: 'Persons' },
  showPeopleLinks: {
    id: 'Show people links',
    defaultMessage: 'Show people links',
  },
  showAreasDescriptions: {
    id: 'Show areas descriptions',
    defaultMessage: 'Show areas descriptions',
  },
});

export const listingPersonsSchema = ({ intl, data }) => {
  const _ = (m) =>
    intl?.formatMessage ? intl.formatMessage(m) : m.defaultMessage;

  return {
    ...baseCardsSchema({ intl }),
    title: _(messages.listingPersons),
    fieldsets: [
      {
        id: 'default',
        title: _(messages.fieldsetDefault),
        fields: ['showAreasDescriptions', 'showPersons'],
      },
      {
        id: 'persons',
        title: _(messages.fieldsetPersons),
        fields: [
          'personsPerRow',
          // 'personCardLayout',
          'summaryCard',
          'peopleLinks',
          'personsShowDescription',
          'showPersonsAllLinks',
          'showPersonsSubstitute',
        ],
      },
    ],
    properties: {
      personsPerRow: {
        title: _(messages.personsPerRow),
        type: 'choice',
        choices: [
          ['1', _(messages.onePerRow)],
          ['2', _(messages.twoPerRow)],
          ['3', _(messages.threePerRow)],
          ['4', _(messages.fourPerRow)],
          ['5', _(messages.fivePerRow)],
        ],
        default: '3',
      },
      personsShowDescription: {
        title: _(messages.showPersonsDescriptions),
        type: 'boolean',
        default: false,
      },
      showPersons: {
        title: _(messages.showPersons),
        type: 'boolean',
        default: true,
        isDisabled: !data?.showAreasDescriptions,
      },

      // personCardLayout: {
      //   title: _(messages.personCardLayout),
      //   type: 'choice',
      //   choices: [
      //     ['vertical', _(messages.vertical)],
      //     ['horizontal', _(messages.horizontal)],
      //   ],
      //   default: 'vertical',
      // },

      summaryCard: {
        title: _(messages.summaryCard),
        type: 'boolean',
      },
      peopleLinks: {
        type: 'boolean',
        title: _(messages.showPeopleLinks),
        default: true,
      },
      showPersonsAllLinks: {
        type: 'boolean',
        title: _(messages.showPersonsAllLinks),
        default: false,
        isDisabled: data?.summaryCard,
      },
      showPersonsSubstitute: {
        type: 'boolean',
        title: _(messages.showPersonsSubstitute),
        default: false,
        isDisabled: data?.summaryCard,
      },
      showAreasDescriptions: {
        type: 'boolean',
        title: _(messages.showAreasDescriptions),
        default: true,
        isDisabled: !data?.showPersons || data?.summaryCard,
      },
    },
  };
};
